/* eofy-bundle.js — Bundle Widget v4 (ESSENTIAL_BUNDLE) */
(function () {
  'use strict';

  var PAID_COUNT = { 2: 2, 4: 4 };
  var FREE_COUNT = { 2: 1, 4: 2 };
  var state = { 2: {}, 4: {} };
  var modal = { tier: null, slot: null, productId: null, variantId: null };

  function init() {
    if (!window.eofyBundle) return;
    hoistModal();
    setupAccordions();
    setupSlotDelegation();
    setupModal();
    setupCTAs();
    prefill();
  }

  function hoistModal() {
    var el = document.getElementById('eofy-bundle-modal');
    if (el && el.parentElement !== document.body) document.body.appendChild(el);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function setupAccordions() {
    document.querySelectorAll('.eofy-bundle__header').forEach(function (h) {
      h.addEventListener('click', function () {
        var card = h.closest('.eofy-bundle__card');
        var wasActive = card.classList.contains('eofy-bundle__card--active');
        document.querySelectorAll('.eofy-bundle__card').forEach(function (c) {
          c.classList.remove('eofy-bundle__card--active');
        });
        if (!wasActive) card.classList.add('eofy-bundle__card--active');
      });
    });
  }

  function setupSlotDelegation() {
    document.querySelectorAll('.eofy-bundle__slot').forEach(function (slot) {
      slot.addEventListener('click', function (e) {
        if (e.target.classList.contains('eofy-bundle__slot-remove')) return;
        if (e.target.classList.contains('eofy-bundle__slot-change')) return;
        if (slot.classList.contains('eofy-bundle__slot--filled') &&
            !e.target.classList.contains('eofy-bundle__slot-change')) return;
        if (slot.classList.contains('eofy-bundle__slot--free') &&
            !slot.classList.contains('eofy-bundle__slot--unlocked')) return;
        openModal(parseInt(slot.dataset.tier, 10), parseInt(slot.dataset.slot, 10));
      });
    });
  }

  function setupModal() {
    document.getElementById('eofy-modal-close').addEventListener('click', closeModal);
    document.getElementById('eofy-modal-backdrop').addEventListener('click', closeModal);
    document.getElementById('eofy-modal-confirm').addEventListener('click', confirmSelection);
  }

  function openModal(tier, slotIdx) {
    modal.tier = tier; modal.slot = slotIdx;
    modal.productId = null; modal.variantId = null;
    renderGroups();
    resetSizeSelector();
    document.getElementById('eofy-bundle-modal').classList.add('eofy-bundle__modal--open');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    document.getElementById('eofy-bundle-modal').classList.remove('eofy-bundle__modal--open');
    document.body.style.overflow = '';
  }

  function renderGroups() {
    var products = window.eofyBundle.products;
    var groupMap = {}, groupOrder = [];
    products.forEach(function (p) {
      if (!groupMap[p.title]) { groupMap[p.title] = []; groupOrder.push(p.title); }
      groupMap[p.title].push(p);
    });
    var container = document.getElementById('eofy-modal-groups');
    container.innerHTML = '';
    groupOrder.forEach(function (title) {
      var group = document.createElement('div');
      group.className = 'eofy-bundle__group';
      var heading = document.createElement('p');
      heading.className = 'eofy-bundle__group-title';
      heading.textContent = title;
      group.appendChild(heading);
      var grid = document.createElement('div');
      grid.className = 'eofy-bundle__product-grid';
      groupMap[title].forEach(function (product) {
        var card = document.createElement('div');
        card.className = 'eofy-bundle__product-card';
        card.dataset.pid = product.id;
        var img = document.createElement('img');
        img.className = 'eofy-bundle__product-card-img';
        img.src = product.image; img.alt = product.colorName || product.title; img.loading = 'lazy';
        var label = document.createElement('span');
        label.className = 'eofy-bundle__product-card-color';
        label.textContent = product.colorName || colorFromHandle(product.handle, product.title);
        card.appendChild(img); card.appendChild(label);
        card.addEventListener('click', function () { selectProduct(product.id); });
        grid.appendChild(card);
      });
      group.appendChild(grid);
      container.appendChild(group);
    });
  }

  function selectProduct(productId) {
    modal.productId = productId; modal.variantId = null;
    document.querySelectorAll('.eofy-bundle__product-card').forEach(function (c) {
      c.classList.toggle('eofy-bundle__product-card--selected', parseInt(c.dataset.pid, 10) === productId);
    });
    renderSizeButtons(productId);
    document.getElementById('eofy-modal-confirm').disabled = true;
  }

  function renderSizeButtons(productId) {
    var product = findProduct(productId);
    if (!product) return;
    var sizesEl = document.getElementById('eofy-sizes');
    sizesEl.innerHTML = '';
    product.variants.forEach(function (v) {
      var btn = document.createElement('button');
      btn.className = 'eofy-bundle__size-btn';
      btn.textContent = v.title; btn.dataset.vid = v.id;
      if (!v.available) btn.disabled = true;
      btn.addEventListener('click', function () {
        sizesEl.querySelectorAll('.eofy-bundle__size-btn').forEach(function (b) {
          b.classList.remove('eofy-bundle__size-btn--selected');
        });
        btn.classList.add('eofy-bundle__size-btn--selected');
        modal.variantId = v.id;
        document.getElementById('eofy-modal-confirm').disabled = false;
      });
      sizesEl.appendChild(btn);
    });
    var sel = document.getElementById('eofy-size-selector');
    sel.classList.add('eofy-bundle__size-selector--visible');
    sel.style.display = 'block';
    setTimeout(function () { sel.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }, 60);
  }

  function resetSizeSelector() {
    var sel = document.getElementById('eofy-size-selector');
    sel.classList.remove('eofy-bundle__size-selector--visible');
    sel.style.display = 'none';
    document.getElementById('eofy-sizes').innerHTML = '';
    document.getElementById('eofy-modal-confirm').disabled = true;
    document.querySelectorAll('.eofy-bundle__product-card--selected').forEach(function (c) {
      c.classList.remove('eofy-bundle__product-card--selected');
    });
  }

  function confirmSelection() {
    if (!modal.productId || !modal.variantId) return;
    var product = findProduct(modal.productId);
    var variant = product.variants.find(function (v) { return v.id === modal.variantId; });
    fillSlot(modal.tier, modal.slot, {
      id: product.id, variantId: modal.variantId, title: product.title,
      colorName: product.colorName || colorFromHandle(product.handle, product.title),
      variantTitle: variant.title, image: product.image
    });
    closeModal();
  }

  function fillSlot(tier, slotIdx, data) {
    state[tier][slotIdx] = data;
    var slot = getSlotEl(tier, slotIdx);
    if (!slot) return;
    var isFreeSlot = slot.classList.contains('eofy-bundle__slot--free');
    slot.classList.add('eofy-bundle__slot--filled');
    var img = document.createElement('img');
    img.className = 'eofy-bundle__slot-img'; img.src = data.image; img.alt = data.title;
    var info = document.createElement('div');
    info.className = 'eofy-bundle__slot-info';
    info.innerHTML =
      '<div class="eofy-bundle__slot-name">' + esc(data.title) + '</div>' +
      '<div class="eofy-bundle__slot-variant">' + esc((data.colorName ? data.colorName + ' · ' : '') + data.variantTitle) + '</div>' +
      (isFreeSlot ? '<div class="eofy-bundle__slot-free-badge">FREE</div>' : '');
    var actions = document.createElement('div');
    actions.className = 'eofy-bundle__slot-actions';
    var changeBtn = document.createElement('button');
    changeBtn.className = 'eofy-bundle__slot-change'; changeBtn.textContent = 'Change';
    changeBtn.addEventListener('click', function (e) { e.stopPropagation(); openModal(tier, slotIdx); });
    var removeBtn = document.createElement('button');
    removeBtn.className = 'eofy-bundle__slot-remove'; removeBtn.setAttribute('aria-label', 'Remove'); removeBtn.textContent = '×';
    removeBtn.addEventListener('click', function (e) { e.stopPropagation(); clearSlot(tier, slotIdx); });
    actions.appendChild(changeBtn); actions.appendChild(removeBtn);
    slot.innerHTML = '';
    slot.appendChild(img); slot.appendChild(info); slot.appendChild(actions);
    syncFreeSlotLock(tier);
    refreshSummary(tier);
    refreshCTA(tier);
  }

  function clearSlot(tier, slotIdx) {
    state[tier][slotIdx] = null;
    var slot = getSlotEl(tier, slotIdx);
    if (!slot) return;
    var isFree = slot.classList.contains('eofy-bundle__slot--free');
    slot.classList.remove('eofy-bundle__slot--filled');
    slot.innerHTML = '<div class="eofy-bundle__slot-empty"><span class="eofy-bundle__slot-plus">+</span><span class="eofy-bundle__slot-label">' + (isFree ? 'Fill the slots above first' : 'Pick item') + '</span></div>';
    syncFreeSlotLock(tier);
    refreshSummary(tier);
    refreshCTA(tier);
  }

  function syncFreeSlotLock(tier) {
    var paidCount = PAID_COUNT[tier];
    var freeCount = FREE_COUNT[tier];
    var allPaid = true;
    for (var i = 0; i < paidCount; i++) { if (!state[tier][i]) { allPaid = false; break; } }
    for (var j = paidCount; j < paidCount + freeCount; j++) {
      var slot = getSlotEl(tier, j);
      if (!slot) continue;
      if (allPaid) {
        slot.classList.add('eofy-bundle__slot--unlocked');
        var lbl = slot.querySelector('.eofy-bundle__slot-label');
        if (lbl && lbl.textContent.indexOf('Fill') !== -1) lbl.textContent = 'Pick your free item';
      } else {
        if (state[tier][j]) { state[tier][j] = null; }
        slot.classList.remove('eofy-bundle__slot--unlocked', 'eofy-bundle__slot--filled');
        slot.innerHTML = '<div class="eofy-bundle__slot-empty"><span class="eofy-bundle__slot-plus">+</span><span class="eofy-bundle__slot-label">Fill the slots above first</span></div>';
      }
    }
  }

  function refreshSummary(tier) {
    var paidCount = PAID_COUNT[tier];
    var paidFilled = 0;
    for (var i = 0; i < paidCount; i++) { if (state[tier][i]) paidFilled++; }
    var el = document.querySelector('.eofy-bundle__summary[data-tier="' + tier + '"]');
    if (!el) return;
    if (paidFilled === 0) { el.classList.add('eofy-bundle__summary--hidden'); return; }
    el.classList.remove('eofy-bundle__summary--hidden');
    /* Price text already set in HTML — JS does not overwrite it */
  }

  function setupCTAs() {
    document.querySelectorAll('.eofy-bundle__cta').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!btn.disabled && !btn.classList.contains('eofy-bundle__cta--loading')) {
          addToCart(parseInt(btn.dataset.tier, 10));
        }
      });
    });
  }

  function refreshCTA(tier) {
    var paidCount = PAID_COUNT[tier];
    var freeCount = FREE_COUNT[tier];
    var allFilled = true;
    for (var i = 0; i < paidCount + freeCount; i++) { if (!state[tier][i]) { allFilled = false; break; } }
    var btn = document.querySelector('.eofy-bundle__cta[data-tier="' + tier + '"]');
    if (btn) btn.disabled = !allFilled;
  }

  function addToCart(tier) {
    var paidCount = PAID_COUNT[tier];
    var totalSlots = paidCount + FREE_COUNT[tier];

    // Add ALL items (paid + free) so the free items show as real lines in the cart.
    // The fixed-amount discount code (applied via redirect below) brings the order
    // total to exactly $100 (3 items) or $200 (6 items).
    // Free-slot items carry a _free_bundle_item property so the cart template can
    // strike their price and label them FREE. The property also keeps a free item
    // on its own cart line even if the same variant was chosen as a paid item.
    var items = [];
    for (var i = 0; i < totalSlots; i++) {
      if (!state[tier][i]) return;
      var props = { _bundle: 'true' };
      if (i >= paidCount) { props._free_bundle_item = 'true'; }
      items.push({ id: state[tier][i].variantId, quantity: 1, properties: props });
    }

    var btn = document.querySelector('.eofy-bundle__cta[data-tier="' + tier + '"]');
    btn.classList.add('eofy-bundle__cta--loading'); btn.disabled = true; btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function (res) { if (!res.ok) throw new Error('Cart add failed'); return res.json(); })
    .then(function () {
      // Pick the discount code from the TOTAL bundle items now in the cart, not just
      // this click — so two "Buy 2 Get 1 Free" bundles (6 items) get the Buy-4-Get-2
      // price (BUNDLE200) + free shipping instead of BUNDLE100 applied only once.
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var bundleQty = 0;
          (cart.items || []).forEach(function (it) {
            if (it.properties && (it.properties._bundle || it.properties._free_bundle_item)) bundleQty += it.quantity;
          });
          // Every 3 bundle shirts = one $100 group → BUNDLE100/200/300...
          // Codes exist up to BUNDLE900 (9 groups / 27 shirts); cap there.
          var groups = Math.floor(bundleQty / 3);
          if (groups < 1) { groups = 1; }
          if (groups > 9) { groups = 9; }
          var code = 'BUNDLE' + (groups * 100);
          window.location.href = '/discount/' + code + '?redirect=/cart';
        });
    })
    .catch(function (err) {
      console.error('[Bundle]', err);
      btn.classList.remove('eofy-bundle__cta--loading'); btn.disabled = false; btn.textContent = 'Add Bundle to Cart';
      alert('Something went wrong. Please try again.');
    });
  }

  function prefill() {
    var cur = window.eofyBundle.currentProduct;
    if (!cur) return;
    [2, 4].forEach(function (tier) {
      fillSlot(tier, 0, { id: cur.id, variantId: cur.variantId, title: cur.title,
        colorName: cur.colorName, variantTitle: cur.variantTitle, image: cur.image });
    });
  }

  function getSlotEl(tier, slotIdx) {
    return document.querySelector('.eofy-bundle__slot[data-tier="' + tier + '"][data-slot="' + slotIdx + '"]');
  }
  function findProduct(id) { return window.eofyBundle.products.find(function (p) { return p.id === id; }); }
  function colorFromHandle(handle, title) {
    var base = title.toLowerCase().replace(/\s+/g, '-');
    var color = handle.replace(new RegExp('^' + base + '-?'), '');
    if (!color) return title;
    return color.split('-').map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1); }).join(' ');
  }
  function esc(str) {
    return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

})();
